import CloseIcon from '@/shared/ui/icons/Components/Common/close-icon.svg';
import { Drawer } from 'antd';
import classnames from 'classnames';
import _ from 'lodash';
import { IconButton } from '@/shared/ui';
import usePatientInfoDrawer from './usePatientInfoDrawer';

export type PatientInfoDrawerProps = {
  studyId: string;
  visible: boolean;
  title: string;
  handleClickCloseButton: () => void;
};

const PatientInfoDrawer = ({
  studyId,
  visible,
  title,
  handleClickCloseButton,
}: PatientInfoDrawerProps) => {
  const { state, handleScroll } = usePatientInfoDrawer({
    studyId,
    visible,
    handleClickCloseButton,
  });

  return (
    <Drawer
      className="custom-drawer"
      width={450}
      closable={false}
      onClose={handleClickCloseButton}
      open={visible}
      aria-label={state.data[0]?.content[0]?.value || title}
    >
      <div
        className={classnames('drawer-title-container', state.isScroll ? '--has-box-shadow' : '')}
      >
        <span className="drawer-title">{state.data[0]?.content[0]?.value || title}</span>
        <IconButton
          isFilled
          iconComponent={<img src={CloseIcon} alt="Close icon" />}
          onClick={handleClickCloseButton}
        />
      </div>

      <div
        className="drawer-body-container style-callcenter"
        onScroll={handleScroll}
        id="drawer-body-container"
      >
        {_.map(
          _.filter(state.data, (x) => !_.isEmpty(x)),
          (element: any, index: number) => (
            <div key={index} className="drawer-body">
              {!!element.header && (
                <div className="drawer-header">
                  <span>{element.header}</span>
                </div>
              )}

              <div className="drawer-content">
                {_.map(
                  _.filter(element.content, (x: any) => !_.isEmpty(x)),
                  (item: any, index: number) => (
                    <div key={index} className="drawer-item">
                      <span>{`${item.label}:`}</span>
                      <span className={item.className}>{item.value}</span>
                    </div>
                  ),
                )}
              </div>
            </div>
          ),
        )}

        <div className="additional-div" />
      </div>
    </Drawer>
  );
};

export default PatientInfoDrawer;
